export const jwtHeader = () => {
  const token = localStorage.getItem("mmbs_access_token")
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  }
  return config
}
